export default __webpack_public_path__ + "static/media/421eb3a3970c22d4034cefcfbf5768ea.svg";